/* eslint-disable react/prop-types */
import * as React from 'react';

import { TextField, makeStyles } from '@material-ui/core';

import { useRef } from 'react';
import Button from 'components/Button/Button'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {},

  messageInputContainer: {
    padding: '4px',
    // ...theme.component.drawerPaper,
    margin: '2px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
  messageInputContainerOverlay: {
    flex: '0 0 auto',
    pointerEvents: 'auto',
    background: 'rgba(0,0,0,0.55)',
    borderRadius: 8,
    '& .MuiOutlinedInput-root': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255,255,255,0.5)',
    },
    '& input::placeholder': {
      color: 'rgba(255,255,255,0.7)',
      opacity: 1,
    },
    '& .MuiButton-root.Mui-disabled': {
      color: 'rgba(255,255,255,0.4)',
    },
  },
}));

export default function CommentInput({ handleCreateComment, overlay }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const inputRef = useRef('');
  const [inputValue, setInputValue] = useState('');

  const submit = () => {
    const comment = inputRef.current.value;
    handleCreateComment(comment);
    setInputValue('');
  };

  const handleInputChange = () => {
    setInputValue(inputRef.current.value);
  };

  const keyPress = (e) => {
    if (e.keyCode === 13) {
      if (e.target.value) {
        submit();
      }
      // put the login here
    }
  };

  return (
    <div
      className={`${classes.messageInputContainer} ${overlay ? classes.messageInputContainerOverlay : ''
        }`}
    >
      <TextField
        id="commentInput"
        variant="outlined"
        size="small"
        fullWidth
        placeholder={`${t('gallery.comment')}...`}
        inputRef={inputRef}
        onChange={handleInputChange}
        value={inputValue}
        onKeyDown={keyPress}
      />

      <Button
        disabled={!inputValue}
        color='primary'
        variant="contained"
        className={classes.actionButton}
        onClick={() => submit()}
      >
        Lähetä
      </Button>
    </div>
  );
}
